// import {
//   Box,
//   Button,
//   TextField,
//   MenuItem,
//   Chip,
//   Switch,
//   Typography,
//   IconButton,
//   InputLabel,
//   FormControl,
//   Select,
// } from "@mui/material";
// import { useFormik } from "formik";
// import * as Yup from "yup";
// import ClearTwoToneIcon from "@mui/icons-material/ClearTwoTone";
// import PersonIcon from "@mui/icons-material/Person";
// import BadgeIcon from "@mui/icons-material/Badge";
// import BuildIcon from "@mui/icons-material/Build";
// import ShieldIcon from "@mui/icons-material/Shield";
// import React, { useEffect, useState } from "react";
// import axiosInstance from "../../../services/axiosInterceptors";
// import apiEndPointsConfig from "../../../services/apiEndPoints";

// const shiftOptions = [
//   { label: "Morning (6 AM - 2 PM)", value: "Morning (6 AM - 2 PM)" },
//   { label: "Afternoon (2 PM - 10 PM)", value: "Afternoon (2 PM - 10 PM)" },
//   { label: "Night (10 PM - 6 AM)", value: "Night (10 PM - 6 AM)" },
//   { label: "Flexible", value: "Flexible" },
// ];

// const roleOptions = [
//   { label: "Admin - Full system access", value: "Admin" },
//   { label: "Manager - Team management", value: "Manager" },
//   { label: "Agent - Call handling", value: "Agent" },
// ];

// const featureLabels = {
//   realTimeAlerts: {
//     title: "Real-time Alerts",
//     desc: "Live notifications during calls",
//   },
//   postCallQA: {
//     title: "Post-Call QA",
//     desc: "Quality-assurance tools",
//   },
//   sentimentAnalysis: {
//     title: "Sentiment Analysis",
//     desc: "Emotional analysis of calls",
//   },
//   transcriptionDownload: {
//     title: "Transcription Download",
//     desc: "Export call transcripts",
//   },
// };

// const initialFormValues = {
//   firstName: "",
//   lastName: "",
//   email: "",
//   employeeId: "",
//   phone: "",
//   location: "",
//   role: "Agent",
//   shift: "",
//   languages: [],
//   features: {
//     realTimeAlerts: false,
//     postCallQA: false,
//     sentimentAnalysis: false,
//     transcriptionDownload: false,
//   },
//   requireMfa: false,
// };

// const schema = Yup.object({
//   firstName: Yup.string().required("First name is required"),
//   lastName: Yup.string().required("Last name is required"),
//   email: Yup.string()
//     .required("Email is required")
//     .matches(
//       /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
//       "Please enter a valid email address"
//     ),

//   employeeId: Yup.string()
//     .required("Employee ID is required")
//     .matches(/^OF\d{3}$/, "Format must be OF followed by 3 digits (e.g. OF123)")
//     .test(
//       "unique",
//       "This Employee ID is already assigned to another user",
//       function (value) {
//         if (!value) return true;
//         const { users = [], user } = this.options.context ?? {};
//         const currentId = user?.agentId;
//         const duplicate = users.some(
//           (u) =>
//             (u.agentId || u.employeeId) === value &&
//             (currentId ? (u.agentId || u.employeeId) !== currentId : true)
//         );
//         return !duplicate;
//       }
//     ),
//   phone: Yup.string()
//     .required("Phone number is required")
//     .test("len", "Phone number must be exactly 10 digits", (val) =>
//       /^\d{10}$/.test(val)
//     ),
//   location: Yup.string().required("Location is required"),
//   role: Yup.string().required("Role is required"),
//   shift: Yup.string().when("role", (r, sch) =>
//     r === "Agent" ? sch.required("Shift is required") : sch
//   ),
//   features: Yup.object({
//     realTimeAlerts: Yup.boolean(),
//     postCallQA: Yup.boolean(),
//     sentimentAnalysis: Yup.boolean(),
//     transcriptionDownload: Yup.boolean(),
//   }),
//   requireMfa: Yup.boolean(),
// });

// function UserForm({ open, onClose, onSave, user, users = [] }) {
//   const [loading, setloading] = useState(false);

//   const formik = useFormik({
//     initialValues: initialFormValues,
//     validationSchema: schema,
//     context: { users, user },
//     validateOnMount: false,
//     validateOnChange: true,
//     validateOnBlur: true,
//     enableReinitialize: true,

//     onSubmit: async (values, { resetForm }) => {
//       const token = localStorage.getItem("token");
//       setloading(true);

//       const body = {
//         firstName: values.firstName,
//         lastName: values.lastName,
//         employeeId: values.employeeId,
//         mobile: values.phone,
//         email: values.email,
//         role: values.role,
//         shiftTiming:
//           values.role === "Agent"
//             ? values.shift.includes("Morning")
//               ? "6 AM - 2 PM"
//               : values.shift.includes("Afternoon")
//               ? "2 PM - 10 PM"
//               : "10 PM - 6 AM"
//             : undefined,
//         location: values.location,
//         status: "active",
//       };

//       try {
//         if (user) {
//           const createUserResponse = await axiosInstance.put(
//             apiEndPointsConfig.updateUser,
//             body,
//             {
//               headers: { Authorization: `Bearer ${token}` },
//             }
//           );
//           console.log("createdResponse", createUserResponse);
//         } else {
//           const updateUserResponse = await axiosInstance.post(
//             apiEndPointsConfig.createUser,
//             body,
//             {
//               headers: { Authorization: `Bearer ${token}` },
//             }
//           );
//           console.log("updateResponse", updateUserResponse);
//         }
//         onSave(values);
//         resetForm();
//         onClose();
//       } catch (err) {
//         console.error("Save user error:", err);
//       } finally {
//         setloading(false);
//       }
//     },
//   });

//   useEffect(() => {
//     if (user) {
//       formik.setValues({
//         ...initialFormValues,
//         ...user,
//         phone: user.mobile ?? "",
//         employeeId: user.agentId || user.employeeId || "",
//         features: user.features || initialFormValues.features,
//       });
//     }
//   }, [user]);

//   const Sec = ({ icon, label }) => (
//     <Box display="flex" alignItems="center" gap={1} mb={2} mt={3}>
//       {icon}
//       <Typography variant="h6" fontWeight={500} fontSize="1rem">
//         {label}
//       </Typography>
//     </Box>
//   );

//   if (!open) return null;

//   return (
//     <Box
//       sx={{
//         position: "fixed",
//         top: 0,
//         right: 0,
//         height: "100vh",
//         width: { xs: "100vw", sm: "80vw", md: "50vw", lg: "50vw" },
//         maxWidth: "100vw",
//         backgroundColor: "#fff",
//         boxShadow: 24,
//         zIndex: 1300,
//         transform: open ? "translateX(0)" : "translateX(100%)",
//         transition: "transform 0.3s ease",
//         display: "flex",
//         flexDirection: "column",
//       }}
//     >
//       <Box
//         sx={{
//           position: "sticky",
//           top: 0,
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "space-between",
//           px: { xs: 2, sm: 3 },
//           py: 2,
//           borderBottom: "1px solid #e0e0e0",
//           backgroundColor: "#fff",
//           zIndex: 999,
//         }}
//       >
//         <Box>
//           <Typography variant="h6" fontWeight={600}>
//             {user ? "Edit User" : "Add New User"}
//           </Typography>
//           <Typography variant="body2" color="text.secondary">
//             {user ? "Edit a user" : "Create a new user account"} with
//             role-specific permissions
//           </Typography>
//         </Box>
//         <IconButton size="small" onClick={onClose}>
//           <ClearTwoToneIcon />
//         </IconButton>
//       </Box>

//       <Box
//         component="form"
//         onSubmit={formik.handleSubmit}
//         sx={{
//           flex: 1,
//           overflowY: "auto",
//           px: { xs: 2, sm: 3 },
//           py: 2,
//           minHeight: 0,
//         }}
//       >
//         <Sec
//           icon={<PersonIcon sx={{ color: "#6366F1" }} />}
//           label="Basic Information"
//         />
//         <Box
//           display="flex"
//           gap={2}
//           mb={2}
//           flexDirection={{ xs: "column", sm: "row" }}
//         >
//           <Box sx={{ flex: 1 }}>
//             <Typography fontWeight={500} fontSize="0.95rem" mb={0.5}>
//               First Name
//             </Typography>
//             <TextField
//               sx={{
//                 "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
//                   {
//                     borderColor: "#6366F1",
//                   },
//               }}
//               size="small"
//               name="firstName"
//               value={formik.values.firstName}
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               error={
//                 formik.touched.firstName && Boolean(formik.errors.firstName)
//               }
//               helperText={formik.touched.firstName && formik.errors.firstName}
//               fullWidth
//             />
//           </Box>
//           <Box sx={{ flex: 1 }}>
//             <Typography fontWeight={500} fontSize="0.95rem" mb={0.5}>
//               Last Name
//             </Typography>
//             <TextField
//              sx={{
//                 "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
//                   {
//                     borderColor: "#6366F1",
//                   },
//               }}
//               size="small"
//               name="lastName"
//               value={formik.values.lastName}
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               error={formik.touched.lastName && Boolean(formik.errors.lastName)}
//               helperText={formik.touched.lastName && formik.errors.lastName}
//               fullWidth
//             />
//           </Box>
//         </Box>

//         <Box sx={{ mb: 2 }}>
//           <Typography fontWeight={500} fontSize="0.95rem" mb={0.5}>
//             Work Email
//           </Typography>
//           <TextField
//             // sx={{ backgroundColor: "#F3F5F7" }}
//             sx={{
//                 "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
//                   {
//                     borderColor: "#6366F1",
//                   },
//               }}
//             fullWidth
//             size="small"
//             name="email"
//             value={formik.values.email}
//             onChange={formik.handleChange}
//             onBlur={formik.handleBlur}
//             error={formik.touched.email && Boolean(formik.errors.email)}
//             helperText={formik.touched.email && formik.errors.email}
//           />
//         </Box>

//         <Box
//           display="flex"
//           gap={2}
//           mb={2}
//           flexDirection={{ xs: "column", sm: "row" }}
//         >
//           <Box sx={{ flex: 1 }}>
//             <Typography fontWeight={500} fontSize="0.95rem" mb={0.5}>
//               Employee ID
//             </Typography>
//             <TextField
//               // sx={{ backgroundColor: "#F3F5F7" }}
//               sx={{
//                 "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
//                   {
//                     borderColor: "#6366F1",
//                   },
//               }}
//               size="small"
//               name="employeeId"
//               placeholder="e.g. OF123"
//               value={formik.values.employeeId}
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               error={
//                 formik.touched.employeeId && Boolean(formik.errors.employeeId)
//               }
//               helperText={formik.touched.employeeId && formik.errors.employeeId}
//               fullWidth
//             />
//           </Box>
//           <Box sx={{ flex: 1 }}>
//             <Typography fontWeight={500} fontSize="0.95rem" mb={0.5}>
//               Phone
//             </Typography>
//             <TextField
//               // sx={{ backgroundColor: "#F3F5F7" }}
//               sx={{
//                 "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
//                   {
//                     borderColor: "#6366F1",
//                   },
//               }}
//               size="small"
//               name="phone"
//               value={formik.values.phone}
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               error={formik.touched.phone && Boolean(formik.errors.phone)}
//               helperText={formik.touched.phone && formik.errors.phone}
//               fullWidth
//             />
//           </Box>
//         </Box>

//         <Box sx={{ mb: 2 }}>
//           <Typography fontWeight={500} fontSize="0.95rem" mb={0.5}>
//             Location / Timezone
//           </Typography>
//           <TextField
//             // sx={{ backgroundColor: "#F3F5F7" }}
//             sx={{
//                 "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
//                   {
//                     borderColor: "#6366F1",
//                   },
//               }}
//             fullWidth
//             size="small"
//             name="location"
//             value={formik.values.location}
//             onChange={formik.handleChange}
//             onBlur={formik.handleBlur}
//             error={formik.touched.location && Boolean(formik.errors.location)}
//             placeholder="e.g. New York, NY"
//           />
//         </Box>

//         {/* Role & Access */}
//         <Sec
//           icon={<BadgeIcon sx={{ color: "#6366F1" }} />}
//           label="Role & Access"
//         />
//         <Box sx={{ mb: 2 }}>
//           <Typography fontWeight={500} fontSize="0.95rem" mb={0.5}>
//             Role
//           </Typography>
//           <FormControl size="small" fullWidth>
//             <InputLabel>Role</InputLabel>
//             <Select
//               // sx={{ backgroundColor: "#F3F5F7" }}
//               sx={{
//                 "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
//                   {
//                     borderColor: "#6366F1",
//                   },
//               }}
//               name="role"
//               value={formik.values.role}
//               label="Role"
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               error={formik.touched.role && Boolean(formik.errors.role)}
//             >
//               {roleOptions.map((r) => (
//                 <MenuItem key={r.value} value={r.value}>
//                   {r.label}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//           {formik.touched.role && formik.errors.role && (
//             <Typography variant="caption" color="error">
//               {formik.errors.role}
//             </Typography>
//           )}
//         </Box>

//         {formik.values.role === "Agent" && (
//           <Box sx={{ mb: 2 }}>
//             <Typography fontWeight={500} fontSize="0.95rem" mb={0.5}>
//               Shift
//             </Typography>
//             <FormControl size="small" fullWidth>
//               <InputLabel>Select Shift</InputLabel>
//               <Select
//                 // sx={{ backgroundColor: "#F3F5F7" }}
//                 sx={{
//                 "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
//                   {
//                     borderColor: "#6366F1",
//                   },
//               }}
//                 name="shift"
//                 value={formik.values.shift}
//                 label="Shift *"
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//                 error={formik.touched.shift && Boolean(formik.errors.shift)}
//               >
//                 {shiftOptions.map((s) => (
//                   <MenuItem key={s.value} value={s.value}>
//                     {s.label}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//             {formik.touched.shift && formik.errors.shift && (
//               <Typography variant="caption" color="error">
//                 {formik.errors.shift}
//               </Typography>
//             )}
//           </Box>
//         )}

//         {/* Feature Access */}
//         <Sec
//           icon={<BuildIcon sx={{ color: "#6366F1" }} />}
//           label="Feature Access"
//         />
//         {Object.entries(formik.values.features).map(([key, val]) => (
//           <Box
//             key={key}
//             display="flex"
//             alignItems="center"
//             justifyContent="space-between"
//             sx={{ mb: 2, px: 1, py: 1, borderRadius: 2 }}
//           >
//             <Box>
//               <Typography fontWeight={500} fontSize="0.95rem">
//                 {featureLabels[key].title}
//               </Typography>
//               <Typography variant="caption" color="text.secondary">
//                 {featureLabels[key].desc}
//               </Typography>
//             </Box>
//             <Switch
//               size="small"
//               checked={val}
//               onChange={(e) =>
//                 formik.setFieldValue(`features.${key}`, e.target.checked)
//               }
//               sx={{
//                 "& .MuiSwitch-thumb": {
//                   backgroundColor: val ? "#6366F1" : "#fff",
//                 },
//                 "& .MuiSwitch-track": {
//                   backgroundColor: val ? "#6366F1" : "#e0e0e0",
//                 },
//               }}
//             />
//           </Box>
//         ))}

//         {/* Security Settings */}
//         <Sec
//           icon={<ShieldIcon sx={{ color: "#6366F1" }} />}
//           label="Security Settings"
//         />
//         <Box
//           display="flex"
//           alignItems="center"
//           justifyContent="space-between"
//           sx={{ mb: 2, px: 1, py: 1, borderRadius: 2 }}
//         >
//           <Box>
//             <Typography fontWeight={500} fontSize="0.95rem">
//               Require MFA
//             </Typography>
//             <Typography variant="caption" color="text.secondary">
//               Multi-factor authentication required
//             </Typography>
//           </Box>
//           <Switch
//             size="small"
//             checked={formik.values.requireMfa}
//             onChange={(e) =>
//               formik.setFieldValue("requireMfa", e.target.checked)
//             }
//             sx={{
//               "& .MuiSwitch-thumb": {
//                 backgroundColor: formik.values.requireMfa ? "#6366F1" : "#fff",
//               },
//               "& .MuiSwitch-track": {
//                 backgroundColor: formik.values.requireMfa
//                   ? "#6366F1"
//                   : "#e0e0e0",
//               },
//             }}
//           />
//         </Box>

//         {/* Actions */}
//         <Box display="flex" justifyContent="flex-end" gap={2} mt={3} mb={2}>
//           <Button onClick={onClose}>Cancel</Button>
//           <Button
//             type="submit"
//             variant="contained"
//             disabled={loading}
//             sx={{ backgroundColor: "#6366F1" }}
//           >
//             {loading
//               ? user
//                 ? "Updating…"
//                 : "Creating…"
//               : user
//               ? "Update User"
//               : "Create User"}
//           </Button>
//         </Box>
//       </Box>
//     </Box>
//   );
// }

// export default UserForm;

import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import axiosInstance from "../../../services/axiosInterceptors";
import apiEndPointsConfig from "../../../services/apiEndPoints";

import {
  Box,
  Button,
  TextField,
  MenuItem,
  Typography,
  IconButton,
  InputLabel,
  FormControl,
  Select,
  Switch,
  Alert,
} from "@mui/material";
import ClearTwoToneIcon from "@mui/icons-material/ClearTwoTone";
import PersonIcon from "@mui/icons-material/Person";
import BadgeIcon from "@mui/icons-material/Badge";
import BuildIcon from "@mui/icons-material/Build";
import ShieldIcon from "@mui/icons-material/Shield";
import { palette, theme  as colorTheme} from "../../../Convoze.theme";
import { BorderClear, BorderColor } from "@mui/icons-material";


const primary = colorTheme("palette", "primary").value;
const primaryBg = colorTheme("palette", "primaryBg").value;
const positive = colorTheme("palette", "positive").value;
const negative = colorTheme("palette", "negative").value;
const neutral = colorTheme("palette", "neutral").value;




/* -------------------------- static data ---------------------------------- */
const shiftOptions = [
  { label: "Morning (6 AM - 2 PM)", value: "Morning (6 AM - 2 PM)" },
  { label: "Afternoon (2 PM - 10 PM)", value: "Afternoon (2 PM - 10 PM)" },
  { label: "Night (10 PM - 6 AM)", value: "Night (10 PM - 6 AM)" },
  { label: "Flexible", value: "Flexible" },
];

const roleDescriptions = {
  Admin: "Admin - Full system access",
  Manager: "Manager - Team management",
  Agent: "Agent - Call handling",
  RoleManager: "Role Manager - View all recordings",
  BranchManager: "Branch Manager - View own recordings",
};

const featureLabels = {
  realTimeAlerts: {
    title: "Real-time Alerts",
    desc: "Live notifications during calls",
  },
  postCallQA: { title: "Post-Call QA", desc: "Quality-assurance tools" },
  sentimentAnalysis: {
    title: "Sentiment Analysis",
    desc: "Emotional analysis of calls",
  },
  transcriptionDownload: {
    title: "Transcription Download",
    desc: "Export call transcripts",
  },
};

/* -------------------------- form model ----------------------------------- */
const initialFormValues = {
  firstName: "",
  lastName: "",
  email: "",
  employeeId: "",
  phone: "",
  location: "",
  role: "Agent",
  shift: "",
  gender: "",
  features: {
    realTimeAlerts: false,
    postCallQA: false,
    sentimentAnalysis: false,
    transcriptionDownload: false,
  },
  requireMfa: false,
};

/* -------------------------- validation ----------------------------------- */
const schema = Yup.object({
  firstName: Yup.string().required("First name is required"),
  lastName: Yup.string().required("Last name is required"),
  email: Yup.string()
    .required("Email is required")
    .email("Please enter a valid email address"),
  employeeId: Yup.string()
    .required("Employee ID is required")
    .matches(/^OF\d{3}$/, "Format must be OF followed by 3 digits (e.g. OF123)")
    .test(
      "unique",
      "This Employee ID is already assigned to another user",
      function (value) {
        if (!value) return true;
        const { users = [], user } = this.options.context ?? {};
        const currentId = user?.id;
        return !users.some(
          (u) => (u.employeeId || u.agentId) === value && u.id !== currentId
        );
      }
    ),
  phone: Yup.string()
    .required("Phone number is required")
    .matches(/^\d{10}$/, "Phone number must be exactly 10 digits"),
  location: Yup.string().required("Location is required"),
  role: Yup.string().required("Role is required"),
  shift: Yup.string().when("role", (r, sch) =>
    r === "Agent" ? sch.required("Shift is required") : sch
  ),
  gender:Yup.string().required("Gender is required"),
  features: Yup.object({
    realTimeAlerts: Yup.boolean(),
    postCallQA: Yup.boolean(),
    sentimentAnalysis: Yup.boolean(),
    transcriptionDownload: Yup.boolean(),
  }),
  requireMfa: Yup.boolean(),
});

/* -------------------------- tiny toast ----------------------------------- */
const Toast = ({ msg, severity = "success", onDone }) => {
  useEffect(() => {
    const t = setTimeout(onDone, 3000);
    return () => clearTimeout(t);
  }, [onDone]);
  return (
    <Box sx={{ position: "fixed", bottom: 24, left: 24, zIndex: 3000 }}>
      <Alert severity={severity} onClose={onDone}>
        {msg}
      </Alert>
    </Box>
  );
};

/* -------------------------- component ------------------------------------ */
function UserForm({ open, onClose, onSave, user, users = [] }) {
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(null);
  const [roleOptions, setRoleOptions] = useState([
    { label: "Admin - Full system access", value: "Admin" },
    { label: "Manager - Team management", value: "Manager" },
    { label: "Agent - Call handling", value: "Agent" },
    { label: roleDescriptions.BranchManager, value: "BranchManager" },
  ]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    axiosInstance
      .get(apiEndPointsConfig.userRoles, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => {
        const roles = res?.data?.data || [];
        if (roles.length) {
          setRoleOptions(
            roles
              .filter((r) => r.value !== "SuperAdmin")
              .map((r) => ({
                value: r.value,
                label: roleDescriptions[r.value] || r.label,
              }))
          );
        }
      })
      .catch(() => {});
  }, []);

  const formik = useFormik({
    initialValues: initialFormValues,
    validationSchema: schema,
    context: { users, user },
    enableReinitialize: true,
    validateOnChange: true,
    validateOnBlur: true,

    onSubmit: async (values) => {
      setLoading(true);
      const token = localStorage.getItem("token");

      const body = {
        firstName: values.firstName,
        lastName: values.lastName,
        employeeId: values.employeeId,
        mobile: values.phone,
        email: values.email,
        role: values.role,
        shiftTiming:
          values.role === "Agent"
            ? values.shift.includes("Morning")
              ? "6 AM - 2 PM"
              : values.shift.includes("Afternoon")
              ? "2 PM - 10 PM"
              : "10 PM - 6 AM"
            : undefined,
        location: values.location,
        gender: values.gender,
        status: "active",
        features: values.features,
        requireMfa: values.requireMfa,
      };

      try {
        if (user) {
          await axiosInstance.put(
            apiEndPointsConfig.updateUser,
            { ...body, id: user.id },
            { headers: { Authorization: `Bearer ${token}` } }
          );
          setToast({ msg: "User updated successfully", severity: "success" });
        } else {
          await axiosInstance.post(apiEndPointsConfig.createUser, body, {
            headers: { Authorization: `Bearer ${token}` },
          });
          setToast({ msg: "User created successfully", severity: "success" });
        }
        onSave(values);
        formik.resetForm();
        onClose();
      } catch (err) {
        console.error("Save user error:", err);
        setToast({
          msg: err?.response?.data?.message || "Operation failed",
          severity: "error",
        });
      } finally {
        setLoading(false);
      }
    },
  });

  useEffect(() => {
    if (user) {
      formik.setValues({
        ...initialFormValues,
        ...user,
        phone: user.mobile ?? "",
        employeeId: user.agentId || user.employeeId || "",
        features: user.features || initialFormValues.features,
      });
    }
  }, [user]);

  if (!open) return null;

  const Sec = ({ icon, label }) => (
    <Box display="flex" alignItems="center" gap={1} mb={2} mt={3}>
      {icon}
      <Typography variant="h6" fontWeight={500} fontSize="1rem">
        {label}
      </Typography>
    </Box>
  );

  /* ---------- reusable styles ---------- */
  const outlinedColor = {
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": 
      {
        //  borderColor: "#6366F1" 
        BorderColor : primary

      },
    },
    "& .MuiOutlinedInput-notchedOutline": {
      legend: { display: "none" },
    },
  };
  const switchStyles = (checked) => ({
    "& .MuiSwitch-thumb": {

       backgroundColor: checked ? primary : "#fff"
       },
    "& .MuiSwitch-track": {
       backgroundColor: checked ? primary : "#e0e0e0"
       },
    "& .MuiInputLabel-root": {
      color: "text.secondary",
      "&.Mui-focused": {
        // color: "#6366F1",
        color : primary
      },
    },
  });

  return (
    <>
      <Box
        sx={{
          position: "fixed",
          top: 0,
          right: 0,
          height: "100vh",
          width: { xs: "100vw", sm: "80vw", md: "50vw", lg: "50vw" },
          maxWidth: "100vw",
          backgroundColor: "#fff",
          boxShadow: 24,
          zIndex: 1300,
          transform: open ? "translateX(0)" : "translateX(100%)",
          transition: "transform 0.3s ease",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* ------- header ------- */}
        <Box
          sx={{
            position: "sticky",
            top: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: { xs: 2, sm: 3 },
            py: 2,
            borderBottom: "1px solid #e0e0e0",
            backgroundColor: "#fff",
            zIndex: 999,
          }}
        >
          <Box>
            <Typography variant="h6" fontWeight={600}>
              {user ? "Edit User" : "Add New User"}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {user ? "Edit a user" : "Create a new user account"} with
              role-specific permissions
            </Typography>
          </Box>
          <IconButton size="small" onClick={onClose}>
            <ClearTwoToneIcon />
          </IconButton>
        </Box>

        {/* ------- body / form ------- */}
        <Box
          component="form"
          onSubmit={formik.handleSubmit}
          sx={{
            flex: 1,
            overflowY: "auto",
            px: { xs: 2, sm: 3 },
            py: 2,
            minHeight: 0,
          }}
        >
          <Sec
            icon={<PersonIcon sx={
              // { color: "#6366F1" }
              {color : primary}
            } />}
            label="Basic Information"
          />
          <Box
            display="flex"
            gap={2}
            mb={2}
            flexDirection={{ xs: "column", sm: "row" }}
          >
            <Box sx={{ flex: 1 }}>
              <Typography fontWeight={500} fontSize="0.95rem" mb={0.5}>
                First Name
              </Typography>
              <TextField
                size="small"
                name="firstName"
                value={formik.values.firstName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.firstName && Boolean(formik.errors.firstName)
                }
                helperText={formik.touched.firstName && formik.errors.firstName}
                fullWidth
                sx={outlinedColor}
              />
            </Box>
            <Box sx={{ flex: 1 }}>
              <Typography fontWeight={500} fontSize="0.95rem" mb={0.5}>
                Last Name
              </Typography>
              <TextField
                size="small"
                name="lastName"
                value={formik.values.lastName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.lastName && Boolean(formik.errors.lastName)
                }
                helperText={formik.touched.lastName && formik.errors.lastName}
                fullWidth
                sx={outlinedColor}
              />
            </Box>
          </Box>

          <Box mb={2}>
            <Typography fontWeight={500} fontSize="0.95rem" mb={0.5}>
              Work Email
            </Typography>
            <TextField
              fullWidth
              size="small"
              name="email"
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.email && Boolean(formik.errors.email)}
              helperText={formik.touched.email && formik.errors.email}
              sx={outlinedColor}
            />
          </Box>

          <Box
            display="flex"
            gap={2}
            mb={2}
            flexDirection={{ xs: "column", sm: "row" }}
          >
            <Box sx={{ flex: 1 }}>
              <Typography fontWeight={500} fontSize="0.95rem" mb={0.5}>
                Employee ID
              </Typography>
              <TextField
                size="small"
                name="employeeId"
                placeholder="e.g. OF123"
                value={formik.values.employeeId}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.employeeId && Boolean(formik.errors.employeeId)
                }
                helperText={
                  formik.touched.employeeId && formik.errors.employeeId
                }
                fullWidth
                sx={outlinedColor}
              />
            </Box>
            <Box sx={{ flex: 1 }}>
              <Typography fontWeight={500} fontSize="0.95rem" mb={0.5}>
                Phone
              </Typography>
              <TextField
                size="small"
                name="phone"
                value={formik.values.phone}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.phone && Boolean(formik.errors.phone)}
                helperText={formik.touched.phone && formik.errors.phone}
                fullWidth
                sx={outlinedColor}
              />
            </Box>
          </Box>

          <Box mb={2}>
            <Typography fontWeight={500} fontSize="0.95rem" mb={0.5}>
              Location / Timezone
            </Typography>
            <TextField
              fullWidth
              size="small"
              name="location"
              value={formik.values.location}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.location && Boolean(formik.errors.location)}
              helperText={formik.touched.location && formik.errors.location}
              placeholder="e.g. New York, NY"
              sx={outlinedColor}
            />
          </Box>

          {/* //Gender */}
          <Box mb={2}>
            <Typography fontWeight={500} fontSize="0.95rem" mb={0.5}>
              Gender
            </Typography>
            <FormControl size="small" fullWidth sx={outlinedColor}>
              <Select
                displayEmpty
                name="gender"
                value={formik.values.gender}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.gender && Boolean(formik.errors.gender)}
              >
                <MenuItem value="" disabled>
                  Select Gender
                </MenuItem>
                <MenuItem value="male">Male</MenuItem>
                <MenuItem value="female">Female</MenuItem>
                <MenuItem value="others">Others</MenuItem>
              </Select>
            </FormControl>
            {formik.touched.gender && formik.errors.gender && (
              <Typography variant="caption" color="error">
                {formik.errors.gender}
              </Typography>
            )}
          </Box>

          {/* Role & Access */}
          <Sec
            icon={<BadgeIcon sx={
              // { color: "#6366F1" }
              {color : primary}
            } />}
            label="Role & Access"
          />
          <Box mb={2}>
            <Typography fontWeight={500} fontSize="0.95rem" mb={0.5}>
              Role
            </Typography>
            <FormControl size="small" fullWidth sx={outlinedColor}>
              <Select
                displayEmpty
                name="role"
                value={formik.values.role}
                label="Role"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.role && Boolean(formik.errors.role)}
              >
                {roleOptions.map((r) => (
                  <MenuItem key={r.value} value={r.value}>
                    {r.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {formik.touched.role && formik.errors.role && (
              <Typography variant="caption" color="error">
                {formik.errors.role}
              </Typography>
            )}
          </Box>

          {formik.values.role === "Agent" && (
            <Box mb={2}>
              <Typography fontWeight={500} fontSize="0.95rem" mb={0.5}>
                Shift
              </Typography>
              <FormControl size="small" fullWidth sx={outlinedColor}>
                <Select
                  name="shift"
                  value={formik.values.shift}
                  label="Shift *"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.shift && Boolean(formik.errors.shift)}
                >
                  <MenuItem value="" disabled>
                    Select Shift
                  </MenuItem>
                  {shiftOptions.map((s) => (
                    <MenuItem key={s.value} value={s.value}>
                      {s.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {formik.touched.shift && formik.errors.shift && (
                <Typography variant="caption" color="error">
                  {formik.errors.shift}
                </Typography>
              )}
            </Box>
          )}

          {/* Feature Access */}
          {/* <Sec icon={<BuildIcon sx={{ color: "#6366F1" }} />} label="Feature Access" />
          {Object.entries(formik.values.features).map(([key, val]) => (
            <Box
              key={key}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              mb={2}
              px={1}
              py={1}
              borderRadius={2}
            >
              <Box>
                <Typography fontWeight={500} fontSize="0.95rem">
                  {featureLabels[key].title}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {featureLabels[key].desc}
                </Typography>
              </Box>
              <Switch
                size="small"
                checked={val}
                onChange={(e) => formik.setFieldValue(`features.${key}`, e.target.checked)}
                sx={switchStyles(val)}
              />
            </Box>
          ))} */}

          {/* Security Settings */}
          {/* <Sec icon={<ShieldIcon sx={{ color: "#6366F1" }} />} label="Security Settings" />
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            mb={2}
            px={1}
            py={1}
            borderRadius={2}
          >
            <Box>
              <Typography fontWeight={500} fontSize="0.95rem">
                Require MFA
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Multi-factor authentication required
              </Typography>
            </Box>
            <Switch
              size="small"
              checked={formik.values.requireMfa}
              onChange={(e) => formik.setFieldValue("requireMfa", e.target.checked)}
              sx={switchStyles(formik.values.requireMfa)}
            />
          </Box> */}

          {/* Actions */}
          <Box display="flex" justifyContent="flex-end" gap={2} mt={3} mb={2}>
            <Button onClick={onClose}>Cancel</Button>
            <Button
              type="submit"
              variant="contained"
              disabled={loading}
              sx={
                // { backgroundColor: "#6366F1" }
                 {backgroundColor : primary} }
            >
              {loading
                ? user
                  ? "Updating…"
                  : "Creating…"
                : user
                ? "Update User"
                : "Create User"}
            </Button>
          </Box>
        </Box>
      </Box>

      {toast && (
        <Toast
          msg={toast.msg}
          severity={toast.severity}
          onDone={() => setToast(null)}
        />
      )}
    </>
  );
}

export default UserForm;
